module.exports = __webpack_public_path__ + "img/template-wire-3.1426911e.jpg";